"use strict";
import { CSRF_HEADER, csrfToken } from "./csrf_token";
export function channelAuthorizationWithCsrf() {
  const headers = {};
  Object.defineProperty(headers, CSRF_HEADER, {
    enumerable: true,
    get: () => {
      var _a;
      return (_a = csrfToken()) != null ? _a : "";
    }
  });
  return {
    transport: "ajax",
    endpoint: "/pusher/auth",
    headers
  };
}
